
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-50 -50 620 620"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M468.114 174.628c-1.829-9.143-9.143-14.629-18.286-14.629h-95.086v-29.257c0-64-45.715-113.371-104.229-113.371-60.342 0-104.228 47.543-104.228 113.371V160H65.829c-9.143 0-16.458 5.486-18.286 14.629L3.657 410.514c-1.829 5.485 0 10.971 3.657 14.629 3.657 3.657 9.143 7.314 14.629 7.314h378.515c10.971 0 18.286-7.314 18.286-18.286s-7.314-18.286-18.286-18.286H43.886l36.571-199.314h64v29.257c0 10.971 7.314 18.286 18.286 18.286s18.286-7.314 18.286-18.286v-29.257h137.142v29.257c0 10.971 7.314 18.286 18.286 18.286s18.286-7.314 18.286-18.286v-29.257h78.628L473.6 416v40.229c0 1.829-1.829 1.829-1.829 1.829H42.057c-1.828 0-5.485-1.829-5.485-1.829 0-10.971-7.314-18.286-18.286-18.286S0 445.257 0 456.228c0 21.943 21.943 38.401 42.057 38.401H473.6c21.943 0 38.4-18.286 38.4-38.401V414.17v-3.657l-43.886-235.885zM316.343 160H181.029v-29.257c0-43.886 29.257-76.8 67.657-76.8 40.229 0 67.658 32.914 67.658 76.8V160z"}})])
          )
        }
      }
    